import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#042957",
        d: "M12.349 8.066 9.125 6.875 7.937 3.649a.995.995 0 0 0-1.867 0L4.875 6.875 1.649 8.063a.995.995 0 0 0 0 1.867l3.226 1.195 1.187 3.226a.994.994 0 0 0 1.868 0l1.195-3.226 3.226-1.187a.995.995 0 0 0 0-1.868zm-3.787 2.198a.5.5 0 0 0-.296.296L7 13.99l-1.264-3.427a.5.5 0 0 0-.299-.3L2.01 9l3.428-1.264a.5.5 0 0 0 .3-.298L7 4.008l1.264 3.428a.5.5 0 0 0 .296.297L11.99 9zM9 2.5a.5.5 0 0 1 .5-.5h1V1a.5.5 0 0 1 1 0v1h1a.5.5 0 1 1 0 1h-1v1a.5.5 0 0 1-1 0V3h-1a.5.5 0 0 1-.5-.5m6.5 3a.5.5 0 0 1-.5.5h-.5v.5a.5.5 0 0 1-1 0V6H13a.5.5 0 0 1 0-1h.5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 .5.5"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }